import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import ContentStatistics from "@/components/Campaign/management/reportingTab/ContentStatistics";
import clsxm from "@/lib/clsxm";
import type {TCarouselMedia} from "@/store/carousel";
import {getContentPermalink} from "@/utils/mediaUtils";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const CarouselContentStatistics: FC<{content: TCarouselMedia; className?: string}> = ({content, className}) => {
  const {t} = useTranslation("common");

  if (
    content.instagram_media?.media_product_type === "UGC" ||
    content.instagram_media?.media_product_type === "SOURCE"
  ) {
    return null;
  }

  const permalink = getContentPermalink({media: content.instagram_media});

  return (
    <div
      className={clsxm(
        "border-neutral-black bg-neutral-black-jet text-neutral-black flex min-h-12 w-full items-center justify-between gap-5 gap-y-1 rounded-sm border px-5 py-2 xl:min-w-111",
        permalink && "hover:bg-neutral-black cursor-pointer",
        className,
      )}
      onClick={e => {
        e.stopPropagation();
        if (permalink) window.open(permalink, "_blank");
      }}>
      <div className="flex w-full min-w-0 flex-col items-center justify-between gap-1 sm:flex-row sm:flex-wrap md:gap-3 lg:gap-10">
        <ContentStatistics className="gap-3 gap-y-1 p-1 text-white md:gap-5" data={{...content.instagram_media}} />
        {permalink && (
          <div className="flex items-center gap-2.5 text-white">
            <span className="text-sm font-medium sm:text-nowrap">
              {t("view_on_platform", {
                platform: t(content.instagram_media?.media_product_type === "TIKTOK" ? "tiktok" : "instagram"),
              })}
            </span>
            <RightArrowIcon className="size-3 shrink-0" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselContentStatistics;
